module.exports = __webpack_public_path__ + "static/media/ava_alert.ca84c521.mp3";